module.exports = __webpack_public_path__ + "img/SUS_KIKE.a6fc61d9.png";